// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: qsV-vn7hyUle
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicContractInstanceCard.module.css"; // plasmic-import: qsV-vn7hyUle/css

createPlasmicElementProxy;

export const PlasmicContractInstanceCard__VariantProps = new Array();

export const PlasmicContractInstanceCard__ArgProps = new Array(
  "amount",
  "status",
  "milestoneNumber",
  "date"
);

const $$ = {};

function PlasmicContractInstanceCard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__ovqou)}>
        {renderPlasmicSlot({
          defaultContents: "$1043.00",
          value: args.amount,
          className: classNames(sty.slotTargetAmount)
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__zqmGb)}>
        {renderPlasmicSlot({
          defaultContents: "Escrow Funded",
          value: args.status,
          className: classNames(sty.slotTargetStatus)
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__fcHx)}>
        {renderPlasmicSlot({
          defaultContents: "2",
          value: args.milestoneNumber,
          className: classNames(sty.slotTargetMilestoneNumber)
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__fwBYl)}>
        {renderPlasmicSlot({
          defaultContents: "Dec 28th, 12:25 AM",
          value: args.date,
          className: classNames(sty.slotTargetDate)
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicContractInstanceCard__ArgProps,
          internalVariantPropNames: PlasmicContractInstanceCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicContractInstanceCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicContractInstanceCard";
  } else {
    func.displayName = `PlasmicContractInstanceCard.${nodeName}`;
  }
  return func;
}

export const PlasmicContractInstanceCard = Object.assign(
  // Top-level PlasmicContractInstanceCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicContractInstanceCard
    internalVariantProps: PlasmicContractInstanceCard__VariantProps,
    internalArgProps: PlasmicContractInstanceCard__ArgProps
  }
);

export default PlasmicContractInstanceCard;
/* prettier-ignore-end */
